var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllfiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0286 2.69545H8.96455C8.75898 2.69545 8.5582 2.61105 8.41955 2.46758L6.83946 0.803082C6.45964 0.424489 5.93999 0.226739 5.41368 0.229771H1.97137C0.884405 0.229739 0 1.11414 0 2.20108V11.7987C0 12.8856 0.884405 13.77 1.97137 13.77H14.0358H14.0377C15.124 13.7652 16.0048 12.8766 16 11.7926V4.66679C16 3.57983 15.1156 2.69545 14.0286 2.69545ZM14.7943 11.7951C14.7961 12.2171 14.4543 12.5625 14.0347 12.5643H1.97137C1.54937 12.5643 1.20575 12.2207 1.20575 11.7987V2.20108C1.20575 1.77908 1.54937 1.43546 1.97137 1.43483H5.42936C5.43599 1.43483 5.44261 1.43483 5.44927 1.43483C5.65061 1.43483 5.84596 1.51502 5.97736 1.64524L7.54902 3.30189C7.91795 3.68289 8.43402 3.90114 8.96455 3.90114H14.0286C14.4506 3.90114 14.7942 4.24476 14.7942 4.66676V11.7951H14.7943Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllfiles);
export default __webpack_public_path__ + "static/media/allfiles.b8bc7672.svg";
export { ForwardRef as ReactComponent };